import httpStatusCode from './httpStatusCode.js';

function mapStatusCodeFromLegacyResponse(resData) {
  if (resData) {
    if (resData.result === -101) {
      return httpStatusCode.unAuthorized;
    }
    if (resData.code === -101) {
      return httpStatusCode.unAuthorized;
    }
  }
  return httpStatusCode.ok;
}

export { mapStatusCodeFromLegacyResponse };
